"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impressionObserverCSFactory = exports.hashImpression32 = void 0;
var ImpressionObserver_1 = require("./ImpressionObserver");
var murmur3_1 = require("../../utils/murmur3/murmur3");
var buildKey_1 = require("./buildKey");
function hashImpression32(impression) {
    return (0, murmur3_1.hash)((0, buildKey_1.buildKey)(impression));
}
exports.hashImpression32 = hashImpression32;
var LAST_SEEN_CACHE_SIZE = 500; // cache up to 500 impression hashes
function impressionObserverCSFactory() {
    return new ImpressionObserver_1.ImpressionObserver(LAST_SEEN_CACHE_SIZE, hashImpression32);
}
exports.impressionObserverCSFactory = impressionObserverCSFactory;
